module.exports = __webpack_public_path__ + "img/img.05ca294a.svg";